module.exports = __webpack_public_path__ + "img/6.687e08a1.jpg";